module.exports = __webpack_public_path__ + "static/img/day3.14551a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/day3.jpg
// module id = tLc1
// module chunks = 0